<template>
  <quiz-form>
    <ButtonUpdate class="mt_m"/>
  </quiz-form>
</template>

<script>
import QuizForm from '@/components/Quiz/Form'
import ButtonUpdate from '@/components/Quiz/ButtonUpdate'

export default {
  components: {
    QuizForm,
    ButtonUpdate
  },

  created: async function () {
    const params = this.$route.params
    await this.$store.dispatch('quiz/getQuiz', params.id)
    await this.$store.dispatch('quiz/retrieveQuizzes', params.quizsetId)
    await this.$store.dispatch('quiz/initForm')
    await this.$store.dispatch('quiz/getSideQuizzes')
  },
}
</script>
